import { Component } from '@angular/core';

@Component({
  selector: 'divisas-capital-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent {
  readonly copyrightYear = new Date().getFullYear();
}
